var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.color },
      }),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-header flex justify-content-between" },
            [
              _c("h5", { staticStyle: { width: "100%" } }, [
                _vm._v("\n            Отчет за "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.moment(_vm.selectedDate, "DD.MM.YYYY"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex" }, [
                _c("p", [
                  _vm._v(
                    "Для просмотра закрытых отчетов, выберите дату в календаре"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedDate,
                        expression: "selectedDate",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedDate = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.getReport,
                      ],
                    },
                  },
                  _vm._l(_vm.datesForSelect, function (d) {
                    return _c("option", { domProps: { value: d.date } }, [
                      _vm._v(
                        _vm._s(_vm.moment(d.date, "DD.MM")) +
                          "\n                (" +
                          _vm._s(_vm.moment(d.date, "dddd", "YYYY-MM-DD")) +
                          ")\n              "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm.reportToday
                    ? _c("div", { staticClass: "alert alert-info" }, [
                        _c("p", [
                          _vm._v(
                            "\n              День еще на закрыт, данные не окончательные - для текущей даты\n            "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    !_vm.hideBlocks.reportHistory
                      ? _c("div", { staticClass: "col-md-6 p-2" }, [
                          _c(
                            "div",
                            { staticClass: "expenses_block fin_stat_block" },
                            [
                              _vm.reportData
                                ? _c("Saldo", {
                                    attrs: {
                                      division: _vm.division.id,
                                      balance: _vm.reportData.balance,
                                      expenses:
                                        _vm.reportData.reportData?.expenses ??
                                        [],
                                      incomes: [
                                        ..._vm.reportData.reportData?.incomes
                                          ?.in,
                                        ..._vm.reportData.reportData?.incomes
                                          ?.out,
                                      ],
                                      exchanges:
                                        _vm.reportData.reportData.exchanges,
                                      orders: _vm.reportData.orders.grouped,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideBlocks.inCash
                      ? _c("div", { staticClass: "col-md-6 p-2" }, [
                          _c(
                            "div",
                            { staticClass: "expenses_block fin_stat_block" },
                            [
                              _vm.chiefRunnerWBalance.length > 1
                                ? [
                                    _c("h6", [
                                      _vm._v("Сальдо старших курьеров"),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.chiefRunnerWBalance,
                                      function (u) {
                                        return _c(
                                          "div",
                                          [
                                            _c("PersonalUserBalance", {
                                              attrs: {
                                                user: u,
                                                division: _vm.division,
                                                date: _vm.selectedDate,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("hr"),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              false
                                ? [
                                    _c("h6", [_vm._v("Текущее сальдо")]),
                                    _vm._v(" "),
                                    _vm.reportData
                                      ? _c("Calculation", {
                                          attrs: {
                                            useLocalCurrency: true,
                                            balance: _vm.reportData.balance,
                                            division: _vm.division.id,
                                            divisions: _vm.divisions,
                                            refreshReport: () =>
                                              _vm.getReport(true),
                                            dayData: _vm.reportData.reportData,
                                            expenses:
                                              _vm.reportData.reportData
                                                ?.expenses ?? [],
                                            incomes: [
                                              ..._vm.reportData.reportData
                                                ?.incomes?.in,
                                              ..._vm.reportData.reportData
                                                ?.incomes?.out,
                                            ],
                                            exchanges:
                                              _vm.reportData.reportData
                                                .exchanges,
                                            orders: _vm.reportData.orders,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideBlocks.expenses &&
                    _vm.reportData &&
                    _vm.reportData.reportData?.expenses &&
                    _vm.reportData.reportData.expenses.length
                      ? _c("div", { staticClass: "col-md-12 p-2" }, [
                          _c(
                            "div",
                            { staticClass: "expenses_block fin_stat_block" },
                            [
                              _c("h5", [_vm._v("Расходы")]),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-sm table-hover table-striped",
                                },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.reportData?.reportData?.expenses ??
                                        [],
                                      function (exp, index) {
                                        return _c("tr", [
                                          _c("td", [_vm._v(_vm._s(index + 1))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.expensesTypes[exp.type_id]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(exp.comment)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [_vm._v(_vm._s(exp.sum))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.printDate(exp.created_at)
                                              )
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  !_vm.hideBlocks.runnerInCashment
                    ? [
                        !_vm.incomes ||
                        (!_vm.incomes.in && !_vm.incomes.out) ||
                        (!_vm.incomes.in.length && !_vm.incomes.out.length)
                          ? _c("div", { staticClass: "alert alert-info" }, [
                              _c("p", [
                                _vm._v(
                                  "\n                В эту дату НЕ БЫЛО поступлений денег Вам с других филиалов и НЕ\n                БЫЛО инкассаций Вашего филиала\n              "
                                ),
                              ]),
                            ])
                          : _c("div", [
                              _vm.incomes &&
                              _vm.incomes.in &&
                              _vm.incomes.in.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "expenses_block fin_stat_block",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "\n                  В эту дату были следующие поступления денег Вам с других\n                  филиалов\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-sm table-striped",
                                        },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              false
                                                ? _c("th", [_vm._v("От кого")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Сумма")]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Валюта")]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Дата")]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Создано")]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Комментарий")]),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.incomes?.in ?? [],
                                              function (income) {
                                                return _c(
                                                  "tr",
                                                  { key: income.id },
                                                  [
                                                    false
                                                      ? _c("td", [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm
                                                                  .$AllDivisions[
                                                                  income
                                                                    .division_id
                                                                ] &&
                                                                  _vm
                                                                    .$AllDivisions[
                                                                    income
                                                                      .division_id
                                                                  ].user.name
                                                              ) +
                                                              "\n                      (" +
                                                              _vm._s(
                                                                (_vm
                                                                  .$AllDivisions[
                                                                  income
                                                                    .division_id
                                                                ] &&
                                                                  _vm
                                                                    .$AllDivisions[
                                                                    income
                                                                      .division_id
                                                                  ].cities &&
                                                                  _vm
                                                                    .$AllDivisions[
                                                                    income
                                                                      .division_id
                                                                  ].cities[0]
                                                                    .city &&
                                                                  _vm
                                                                    .$AllDivisions[
                                                                    income
                                                                      .division_id
                                                                  ].cities[0]
                                                                    .city
                                                                    .name) ||
                                                                  "Не указан"
                                                              ) +
                                                              ")\n                    "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            (
                                                              income?.sum ?? 0
                                                            ).toLocaleString(
                                                              "ru-RU"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$AllCurrencies[
                                                            income.currency_id
                                                          ].currency
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          income.report_date
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.printDate(
                                                            income.created_at
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(income.comment)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr"),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "expenses_block fin_stat_block",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "В эту дату НЕ БЫЛО поступлений денег Вам с других филиалов"
                                        ),
                                      ]),
                                    ]
                                  ),
                              _vm._v(" "),
                              _vm.incomes &&
                              _vm.incomes.out &&
                              _vm.incomes.out.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "expenses_block fin_stat_block",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "\n                  В эту дату проведены следующие инкассации\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-sm table-striped",
                                        },
                                        [
                                          _vm._m(1),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.incomes?.out ?? [],
                                              function (income) {
                                                return _c(
                                                  "tr",
                                                  { key: income.id },
                                                  [
                                                    _c("td", [
                                                      !income.to_division_id
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "Администрация"
                                                            ),
                                                          ])
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .$AllDivisions[
                                                                  income
                                                                    .to_division_id
                                                                ] &&
                                                                  _vm
                                                                    .$AllDivisions[
                                                                    income
                                                                      .to_division_id
                                                                  ].user.name
                                                              ) +
                                                                "\n                        (" +
                                                                _vm._s(
                                                                  _vm
                                                                    .$AllDivisions[
                                                                    income
                                                                      .to_division_id
                                                                  ] &&
                                                                    _vm
                                                                      .$AllDivisions[
                                                                      income
                                                                        .to_division_id
                                                                    ].cities[0]
                                                                      .city.name
                                                                ) +
                                                                ")"
                                                            ),
                                                          ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            income.sum.toLocaleString(
                                                              "ru-RU"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$AllCurrencies[
                                                            income.currency_id
                                                          ].currency
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          income.report_date
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.printDate(
                                                            income.created_at
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(income.comment)
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "expenses_block fin_stat_block",
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "В эту дату НЕ БЫЛО инкассаций Вашего филиала"
                                        ),
                                      ]),
                                    ]
                                  ),
                            ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm.ordersCashDetails.total &&
                            Object.keys(_vm.ordersCashDetails.total).length > 1
                              ? [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-sm table-hover table-striped summary_runner_table",
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v("Курьер")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Общая сумма")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Ф. Надб")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("З/П без фикс")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Оплата доставок")]),
                                          _vm._v(" "),
                                          _vm.customSalaryCalculation
                                            ? _c("th", [_vm._v("З/П курьера")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showPostExpenses
                                            ? _c("th", [
                                                _vm._v("Почтовые расходы"),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("Сумма безнала")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("К сдаче, курьер")]),
                                          _vm._v(" "),
                                          _c("th", [_vm._v("К сдаче, админ")]),
                                          _vm._v(" "),
                                          _vm.customSalaryCalculation &&
                                          _vm.showColumn.remainDivision
                                            ? _c("th", [
                                                _vm._v("Остаток филиал"),
                                              ])
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        [
                                          _vm._l(
                                            _vm.sortedRunners,
                                            function (runner) {
                                              return _c(
                                                "tr",
                                                { key: runner.id },
                                                [
                                                  _c("td", [
                                                    _vm._v(_vm._s(runner.name)),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ordersCashDetails
                                                          .total[runner.id]
                                                          ?.sum ?? 0
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ordersCashDetails
                                                          ?.total[runner.id]
                                                          ?.extra ?? 0
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        Math.round(
                                                          ((_vm
                                                            .ordersCashDetails
                                                            .total[runner.id]
                                                            ?.salary ?? 0) -
                                                            (_vm
                                                              .ordersCashDetails
                                                              ?.total?.[
                                                              runner.id
                                                            ]?.extra ?? 0)) *
                                                            10
                                                        ) / 10
                                                      ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          Math.round(
                                                            _vm
                                                              .ordersCashDetails
                                                              .total[runner.id]
                                                              ?.salary ?? 0
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.customSalaryCalculation
                                                    ? _c("td", [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm
                                                                .ordersCashDetails
                                                                .total[
                                                                runner.id
                                                              ]
                                                                ?.all_cleared_salary ??
                                                                0
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.showPostExpenses
                                                    ? _c("td")
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ordersCashDetails
                                                          .total[runner.id]
                                                          ?.noCash ?? 0
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "runner_salary_color",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm
                                                              .ordersCashDetails
                                                              .total[runner.id]
                                                              ?.clear_price ??
                                                              (_vm
                                                                .ordersCashDetails
                                                                .total[
                                                                runner.id
                                                              ]?.sum ?? 0) -
                                                                (_vm
                                                                  .ordersCashDetails
                                                                  .total[
                                                                  runner.id
                                                                ]?.noCash ??
                                                                  0) -
                                                                (_vm
                                                                  .ordersCashDetails
                                                                  .total[
                                                                  runner.id
                                                                ]?.salary ?? 0)
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getTotalFigures(
                                                            "passToAdmin",
                                                            runner.id
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.customSalaryCalculation &&
                                                  _vm.showColumn.remainDivision
                                                    ? _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "remain_division_color",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                (_vm
                                                                  .ordersCashDetails
                                                                  .total[
                                                                  runner.id
                                                                ]?.sum ?? 0) -
                                                                  (_vm
                                                                    .ordersCashDetails
                                                                    .total[
                                                                    runner.id
                                                                  ]?.noCash ??
                                                                    0) -
                                                                  (_vm
                                                                    .ordersCashDetails
                                                                    .total[
                                                                    runner.id
                                                                  ]
                                                                    ?.all_cleared_salary ??
                                                                    0) -
                                                                  ((_vm
                                                                    .ordersCashDetails
                                                                    .total[
                                                                    runner.id
                                                                  ]?.sum ?? 0) -
                                                                    (_vm
                                                                      .ordersCashDetails
                                                                      .total[
                                                                      runner.id
                                                                    ]?.noCash ??
                                                                      0) -
                                                                    (_vm
                                                                      .ordersCashDetails
                                                                      .total[
                                                                      runner.id
                                                                    ]?.salary ??
                                                                      0))
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "tr",
                                            { staticClass: "total_tr" },
                                            [
                                              _c("td", [_vm._v("ИТОГО")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.ordersCashDetails
                                                        .total[0]?.sum ?? 0
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.ordersCashDetails
                                                        .total[0]?.extra ?? 0
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      (_vm.ordersCashDetails
                                                        .total[0]?.salary ??
                                                        0) -
                                                        (_vm.ordersCashDetails
                                                          .total[0]?.extra ?? 0)
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      Math.round(
                                                        (_vm.ordersCashDetails
                                                          .total[0]?.salary ??
                                                          0) * 10
                                                      ) / 10
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _vm.customSalaryCalculation
                                                ? _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ordersCashDetails
                                                          .total[0]
                                                          ?.all_cleared_salary ??
                                                          0
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showPostExpenses
                                                ? _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ordersCashDetails
                                                          .total[0]?.post_sum ??
                                                          0
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ordersCashDetails
                                                      .total[0]?.noCash ?? 0
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "runner_salary_color",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.ordersCashDetails
                                                          .total[0]
                                                          ?.clear_price ??
                                                          (_vm.ordersCashDetails
                                                            .total[0]?.sum ??
                                                            0) -
                                                            (_vm
                                                              .ordersCashDetails
                                                              .total[0]
                                                              ?.noCash ?? 0) -
                                                            (_vm
                                                              .ordersCashDetails
                                                              .total[0]
                                                              ?.salary ?? 0)
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.ordersCashDetails
                                                        .total[0]
                                                        ?.clear_price ??
                                                        (_vm.ordersCashDetails
                                                          .total[0]?.sum ?? 0) -
                                                          (_vm.ordersCashDetails
                                                            .total[0]?.noCash ??
                                                            0) -
                                                          (_vm.ordersCashDetails
                                                            .total[0]
                                                            ?.all_salary ?? 0) -
                                                          (_vm.ordersCashDetails
                                                            .total[0]
                                                            ?.post_sum ?? 0)
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _vm.customSalaryCalculation &&
                                              _vm.showColumn.remainDivision
                                                ? _c("td", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          (_vm.ordersCashDetails
                                                            .total[0]?.sum ??
                                                            0) -
                                                            (_vm
                                                              .ordersCashDetails
                                                              .total[0]
                                                              ?.noCash ?? 0) -
                                                            (_vm
                                                              .ordersCashDetails
                                                              .total[0]
                                                              ?.all_cleared_salary ??
                                                              0) -
                                                            (_vm
                                                              .ordersCashDetails
                                                              .total[0]
                                                              ?.post_sum ?? 0) -
                                                            ((_vm
                                                              .ordersCashDetails
                                                              .total[0]?.sum ??
                                                              0) -
                                                              (_vm
                                                                .ordersCashDetails
                                                                .total[0]
                                                                ?.noCash ?? 0) -
                                                              (_vm
                                                                .ordersCashDetails
                                                                .total[0]
                                                                ?.all_salary ??
                                                                0) -
                                                              (_vm
                                                                .ordersCashDetails
                                                                .total[0]
                                                                ?.post_sum ??
                                                                0))
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]
                              : [_vm._m(2)],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("hr"),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedRunner,
                            expression: "selectedRunner",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedRunner = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.updateOrderList,
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v("Все курьеры"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.sortedRunners, function (runner) {
                          return _c(
                            "option",
                            { key: runner.id, domProps: { value: runner.id } },
                            [_vm._v(_vm._s(runner.name) + "\n              ")]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.orders.length
                    ? [_vm._m(3)]
                    : [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-hover table-sm table-bordered table-striped",
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("№")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Доставка")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Клиент")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Препараты")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Общая сумма")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("З/П курьера")]),
                                _vm._v(" "),
                                _vm.showChiefRunnerSalary
                                  ? _c("th", [_vm._v("З/П агента")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showPostExpenses
                                  ? _c("th", [_vm._v("Почтовые р.")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("th", [_vm._v("к сдаче курьер")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("к сдаче админ")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Адрес")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Курьер")]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _c("tr", { staticClass: "total_tr" }, [
                                  _c("td", { attrs: { colspan: "4" } }, [
                                    _vm._v("ИТОГО"),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.ordersCashDetails.total[
                                          _vm.selectedRunner
                                        ]?.sum ?? 0
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTotalFigures("runnerSalary")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.showChiefRunnerSalary
                                    ? _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            Math.round(
                                              _vm.getTotalFigures(
                                                "chiefRunnerSalary"
                                              ) * 10
                                            ) / 10
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTotalFigures("runnerToPass")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.showPostExpenses
                                    ? _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ordersCashDetails.total[
                                              _vm.selectedRunner
                                            ].post_sum
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.ordersCashDetails.total[
                                            _vm.selectedRunner
                                          ]?.clear_price ??
                                            (_vm.ordersCashDetails.total[
                                              _vm.selectedRunner
                                            ]?.sum ?? 0) -
                                              (_vm.customSalaryCalculation
                                                ? _vm.ordersCashDetails.total[
                                                    _vm.selectedRunner
                                                  ]?.all_cleared_salary ?? 0
                                                : _vm.ordersCashDetails.total[
                                                    _vm.selectedRunner
                                                  ]?.all_salary ?? 0) -
                                              _vm.inCreditCardSum -
                                              (_vm.ordersCashDetails.total[
                                                _vm.selectedRunner
                                              ]?.post_sum ?? 0)
                                        ) +
                                        "\n                  "
                                    ),
                                    _vm.inCreditCardSum
                                      ? _c("p", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-info fs-14",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-credit-card",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.inCreditCardSum)
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "10" } }),
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.orders, function (order, index) {
                                  return _c("tr", { key: index }, [
                                    _c("td", { staticClass: "phone_num" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.mixinPrintOrderNum(order.id)
                                          ) +
                                          "\n                  "
                                      ),
                                      order.sub_status ===
                                      _vm.subStatus_closedByTablet
                                        ? _c("div", [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-tablet",
                                            }),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moment(
                                            order.report_date,
                                            "HH:mm:ss"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              order.client_name ||
                                                "не определен"
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          order.order_phones,
                                          function (p, ind) {
                                            return _c(
                                              "p",
                                              {
                                                key: ind,
                                                staticClass: "phone_num",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.mixinPrintPhone(
                                                        p.phone.phone
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      _vm._l(
                                        order.details,
                                        function (drug, ind) {
                                          return _c("div", { key: ind }, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(drug.new_drug.title) +
                                                " (" +
                                                _vm._s(drug.drug_id) +
                                                ") - " +
                                                _vm._s(
                                                  drug.qty /
                                                    (drug.new_drug.pack_set ||
                                                      1)
                                                ) +
                                                "\n                    "
                                            ),
                                            +drug.new_drug.pack_set !== 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "alert alert-danger m-0 p-1 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          drug.qty /
                                                            (drug.new_drug
                                                              .pack_set || 1)
                                                        ) +
                                                        " комплект (" +
                                                        _vm._s(drug.qty) +
                                                        " зав.упак.)\n                    "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex pack_details_block",
                                              },
                                              [
                                                drug.new_drug.holod
                                                  ? [
                                                      _c("div", [
                                                        _c("i", {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value: {
                                                                content:
                                                                  "Требуется хладоген",
                                                                placement:
                                                                  "bottom-center",
                                                                classes: [
                                                                  "info",
                                                                ],
                                                                targetClasses: [
                                                                  "it-has-a-tooltip",
                                                                ],
                                                                offset: 20,
                                                                delay: {
                                                                  show: 500,
                                                                  hide: 300,
                                                                },
                                                              },
                                                              expression:
                                                                "{\n                        content: 'Требуется хладоген',\n                        placement: 'bottom-center',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 20,\n                        delay: {\n                          show: 500,\n                          hide: 300\n                        }\n                      }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "icon icon-snowflake pointer",
                                                        }),
                                                      ]),
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                drug.new_drug.pack_comment
                                                  ? [
                                                      _c("div", [
                                                        _c("i", {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip",
                                                              value: {
                                                                content:
                                                                  drug.new_drug
                                                                    .pack_comment,
                                                                placement:
                                                                  "bottom-center",
                                                                classes: [
                                                                  "info",
                                                                ],
                                                                targetClasses: [
                                                                  "it-has-a-tooltip",
                                                                ],
                                                                offset: 20,
                                                                delay: {
                                                                  show: 500,
                                                                  hide: 300,
                                                                },
                                                              },
                                                              expression:
                                                                "{\n                        content: drug.new_drug.pack_comment,\n                        placement: 'bottom-center',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 20,\n                        delay: {\n                          show: 500,\n                          hide: 300\n                        }\n                      }",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "icon-fa icon-fa-info-circle",
                                                        }),
                                                      ]),
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                drug.new_drug.pack_box_comment
                                                  ? [
                                                      _c("i", {
                                                        directives: [
                                                          {
                                                            name: "tooltip",
                                                            rawName:
                                                              "v-tooltip",
                                                            value: {
                                                              content:
                                                                drug.new_drug
                                                                  .pack_box_comment,
                                                              placement:
                                                                "bottom-center",
                                                              classes: ["info"],
                                                              targetClasses: [
                                                                "it-has-a-tooltip",
                                                              ],
                                                              offset: 20,
                                                              delay: {
                                                                show: 500,
                                                                hide: 300,
                                                              },
                                                            },
                                                            expression:
                                                              "{\n                      content: drug.new_drug.pack_box_comment,\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "icon-fa icon-fa-home",
                                                      }),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              order.currency_id &&
                                                order.currency_id !==
                                                  _vm.$platformConstants
                                                    .operationCurrency.id
                                                ? order.currency_id_price
                                                : order.price
                                            ) +
                                            "\n                  "
                                        ),
                                        order.pay_method === 3
                                          ? [
                                              _c("p", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-info fs-14",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-credit-card",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          order.no_cash_price
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              +order.no_cash_price <
                                              +order.price
                                                ? [
                                                    _c("p", [
                                                      _vm._v(
                                                        "₽ " +
                                                          _vm._s(
                                                            +order.price -
                                                              +order.no_cash_price
                                                          )
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          order.currency_id &&
                                            order.currency_id !==
                                              _vm.$platformConstants
                                                .operationCurrency.id
                                            ? order.currency_salary ?? 0
                                            : order.extra_options?.salary ?? 0
                                        ) + "\n                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm.showChiefRunnerSalary
                                      ? _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              Math.round(
                                                (order.extra_options
                                                  ?.chief_runner_salary ?? 0) *
                                                  10
                                              ) / 10
                                            ) + "\n                "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        order.pay_method === 3
                                          ? [_vm._v("0")]
                                          : [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    order.currency_id &&
                                                      order.currency_id !==
                                                        _vm.$platformConstants
                                                          .operationCurrency.id
                                                      ? order.currency_clear_price
                                                      : order.price -
                                                          (order.extra_options
                                                            ?.salary ?? 0) -
                                                          (order.extra_options
                                                            ?.post_sum ?? 0)
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm.showPostExpenses
                                      ? _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              order.extra_options?.post_sum ?? 0
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        order.pay_method === 3
                                          ? [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    +order.price -
                                                      +order.no_cash_price -
                                                      ((_vm.customSalaryCalculation
                                                        ? order.extra_options
                                                            ?.clear_salary ?? 0
                                                        : order.salary ?? 0) -
                                                        (order.extra_options
                                                          ?.post_sum ?? 0))
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "fs-14" },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-credit-card",
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        order.no_cash_price
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    order.currency_id &&
                                                      order.currency_id !==
                                                        _vm.$platformConstants
                                                          .operationCurrency.id
                                                      ? order.currency_clear_price
                                                      : order?.clear_price ??
                                                          order.price -
                                                            (order?.all_expenses ??
                                                              0)
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(order.address) +
                                          "\n                  "
                                      ),
                                      +(order.extra_options?.salary_rate ?? 0)
                                        ? _c("p", [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "badge badge-info",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$platformConstants
                                                      .salaryRateTitles?.[
                                                      order.extra_options
                                                        ?.salary_rate
                                                    ] ?? "не определено"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            (_vm.runners[order.runner_id] &&
                                              _vm.runners[order.runner_id]
                                                .name) ||
                                              "не определен"
                                          ) +
                                          "\n                "
                                      ),
                                    ]),
                                  ])
                                }),
                                _vm._v(" "),
                                _c("tr", { staticClass: "total_tr" }, [
                                  _c("td", { attrs: { colspan: "4" } }, [
                                    _vm._v("ИТОГО"),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.ordersCashDetails.total[
                                          _vm.selectedRunner
                                        ]?.sum ?? 0
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTotalFigures("runnerSalary")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.showChiefRunnerSalary
                                    ? _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getTotalFigures(
                                              "chiefRunnerSalary"
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTotalFigures("runnerToPass")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.showPostExpenses
                                    ? _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.ordersCashDetails.total[
                                              _vm.selectedRunner
                                            ]?.post_sum ?? 0
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.ordersCashDetails.total[
                                            _vm.selectedRunner
                                          ]?.clear_price ??
                                            (_vm.ordersCashDetails.total[
                                              _vm.selectedRunner
                                            ]?.sum ?? 0) -
                                              (_vm.customSalaryCalculation
                                                ? _vm.ordersCashDetails.total[
                                                    _vm.selectedRunner
                                                  ]?.all_cleared_salary ?? 0
                                                : _vm.ordersCashDetails.total[
                                                    _vm.selectedRunner
                                                  ]?.all_salary ?? 0) -
                                              _vm.inCreditCardSum -
                                              (_vm.ordersCashDetails.total[
                                                _vm.selectedRunner
                                              ]?.post_sum ?? 0)
                                        ) +
                                        "\n                  "
                                    ),
                                    _vm.inCreditCardSum
                                      ? _c("p", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-info fs-14",
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-credit-card",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.inCreditCardSum)
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "10" } }),
                                ]),
                              ],
                              2
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.rejectedOrders && _vm.rejectedOrders.length
                          ? _c("div", [
                              _c("h5", [_vm._v("Текущие отказы")]),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-sm table-hover table-bordered table-striped",
                                },
                                [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.rejectedOrders,
                                      function (order) {
                                        return _c("tr", { key: order.id }, [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.mixinPrintOrderNum(order.id)
                                              ) + "\n                    "
                                            ),
                                            order.sub_status ===
                                            _vm.subStatus_rejectedByTablet
                                              ? _c("div", [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-tablet",
                                                  }),
                                                ])
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            _vm._l(
                                              order.details,
                                              function (drug, ind) {
                                                return _c("p", { key: ind }, [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        drug.new_drug.title
                                                      ) +
                                                      " (" +
                                                      _vm._s(drug.drug_id) +
                                                      ") - " +
                                                      _vm._s(drug.qty) +
                                                      "\n                    "
                                                  ),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  (_vm.runners[
                                                    order.runner_id
                                                  ] &&
                                                    _vm.runners[order.runner_id]
                                                      .name) ||
                                                    "Старший курьер"
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(order.reject_comment) +
                                                "\n                  "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.moment(
                                                    order.report_date,
                                                    "HH:mm"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Тип расхода")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Кому")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Валюта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Создано")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [_vm._v("Нет закрытых заявок в текущих условиях")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [_vm._v("Нет заявок в текущих условиях")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Исполнитель")]),
        _vm._v(" "),
        _c("th", [_vm._v("Причина отказа")]),
        _vm._v(" "),
        _c("th", [_vm._v("Время")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }